import React from "react";
import Card from "../../components/Global/Card";
import { AiOutlineUser } from "react-icons/ai";
import { connect } from "react-redux";

function Profile({user}) {
  return (
    <div className="flex flex-col w-full gap-3">
      <Card title="Informações Gerais do usuário" icon={<AiOutlineUser className="w-[25px] h-[25px]" />}>
        <div className="p-4 flex flex-col gap-5">
          {/* Seção da foto e botão de alterar */}
          {/* <div className="flex flex-col items-center gap-5">
            <div className="w-[125px] h-[125px] rounded-full bg-blue-dark-default flex justify-center items-center text-white">
              <BsFillPersonFill style={{ color: "white", fontSize: "85px" }} />
            </div>
            <div>
              <button className="bg-green-default hover:bg-green-dark-default text-white px-5 py-1 rounded-[4px]">
                Alterar foto
              </button>
            </div>
          </div> */}

          {/* Seção das informações do perfil */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full">
            <div className="flex flex-col">
              <span className="font-bold">Nome</span>
              <span>{user.nome}</span>
            </div>
            <div className="flex flex-col">
              <span className="font-bold">CPF</span>
              <span>{user.cpf}</span>
            </div>

            <div className="flex flex-col">
              <span className="font-bold">Email</span>
              <span>{user.email}</span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  login: (userData) => dispatch({ type: "LOGIN_SUCCESS", payload: userData }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);